var linkBlocks = document.querySelectorAll('.linkBlock')
Array.prototype.forEach.call(linkBlocks, function (linkBlock) {
  var down
  var up
  var link = linkBlock.querySelector('.linkBlock a')
  linkBlock.style.cursor = 'pointer'

  linkBlock.onmousedown = function () {
    return (down = +new Date())
  }

  linkBlock.onmouseup = function () {
    up = +new Date()

    if (up - down < 200) {
      link.click()
    }
  }
})
